
import { WorldCountry } from './types';

export const additionalCountries: WorldCountry[] = [
  {
    name: 'Vatican City',
    slug: 'vatican-city',
    code: 'VA',
    population: 825,
    topCities: [
      { name: 'Vatican City', slug: 'vatican-city', population: 825 }
    ]
  },
  {
    name: 'Monaco',
    slug: 'monaco',
    code: 'MC',
    population: 39242,
    topCities: [
      { name: 'Monaco', slug: 'monaco-city', population: 39242 }
    ]
  },
  {
    name: 'San Marino',
    slug: 'san-marino',
    code: 'SM',
    population: 33931,
    topCities: [
      { name: 'San Marino', slug: 'san-marino-city', population: 4500 },
      { name: 'Serravalle', slug: 'serravalle', population: 10878 },
      { name: 'Borgo Maggiore', slug: 'borgo-maggiore', population: 6871 },
      { name: 'Domagnano', slug: 'domagnano', population: 3565 },
      { name: 'Fiorentino', slug: 'fiorentino', population: 2348 }
    ]
  },
  {
    name: 'Liechtenstein',
    slug: 'liechtenstein',
    code: 'LI',
    population: 38128,
    topCities: [
      { name: 'Vaduz', slug: 'vaduz', population: 5696 },
      { name: 'Schaan', slug: 'schaan', population: 6039 },
      { name: 'Balzers', slug: 'balzers', population: 4420 },
      { name: 'Triesen', slug: 'triesen', population: 5112 },
      { name: 'Eschen', slug: 'eschen', population: 4629 }
    ]
  },
  {
    name: 'Andorra',
    slug: 'andorra',
    code: 'AD',
    population: 77265,
    topCities: [
      { name: 'Andorra la Vella', slug: 'andorra-la-vella', population: 22886 },
      { name: 'Escaldes-Engordany', slug: 'escaldes-engordany', population: 14395 },
      { name: 'Encamp', slug: 'encamp', population: 11223 },
      { name: 'Sant Julià de Lòria', slug: 'sant-julia-de-loria', population: 9208 },
      { name: 'La Massana', slug: 'la-massana', population: 9744 }
    ]
  },
  {
    name: 'Malta',
    slug: 'malta',
    code: 'MT',
    population: 441543,
    topCities: [
      { name: 'Valletta', slug: 'valletta', population: 6444 },
      { name: 'Birkirkara', slug: 'birkirkara', population: 24148 },
      { name: 'Mosta', slug: 'mosta', population: 20241 },
      { name: 'Qormi', slug: 'qormi', population: 16324 },
      { name: 'Żabbar', slug: 'zabbar', population: 15404 },
      { name: 'San Pawl il-Baħar', slug: 'san-pawl-il-bahar', population: 15109 },
      { name: 'Sliema', slug: 'sliema', population: 12129 },
      { name: 'Naxxar', slug: 'naxxar', population: 13443 },
      { name: 'Żejtun', slug: 'zejtun', population: 11218 },
      { name: 'Rabat', slug: 'rabat-malta', population: 11497 }
    ]
  },
  {
    name: 'Cyprus',
    slug: 'cyprus',
    code: 'CY',
    population: 1207359,
    topCities: [
      { name: 'Nicosia', slug: 'nicosia', population: 330000 },
      { name: 'Limassol', slug: 'limassol', population: 235056 },
      { name: 'Larnaca', slug: 'larnaca', population: 144200 },
      { name: 'Paphos', slug: 'paphos', population: 62700 },
      { name: 'Famagusta', slug: 'famagusta', population: 42526 },
      { name: 'Kyrenia', slug: 'kyrenia', population: 33207 },
      { name: 'Morphou', slug: 'morphou', population: 14000 },
      { name: 'Paralimni', slug: 'paralimni', population: 12721 },
      { name: 'Protaras', slug: 'protaras', population: 8689 },
      { name: 'Ayia Napa', slug: 'ayia-napa', population: 3335 }
    ]
  },
  {
    name: 'Luxembourg',
    slug: 'luxembourg',
    code: 'LU',
    population: 625978,
    topCities: [
      { name: 'Luxembourg City', slug: 'luxembourg-city', population: 125000 },
      { name: 'Esch-sur-Alzette', slug: 'esch-sur-alzette', population: 35040 },
      { name: 'Differdange', slug: 'differdange', population: 26335 },
      { name: 'Dudelange', slug: 'dudelange', population: 21074 },
      { name: 'Ettelbruck', slug: 'ettelbruck', population: 9086 },
      { name: 'Diekirch', slug: 'diekirch', population: 6068 },
      { name: 'Strassen', slug: 'strassen', population: 10570 },
      { name: 'Bertrange', slug: 'bertrange', population: 8996 },
      { name: 'Bettembourg', slug: 'bettembourg', population: 10675 },
      { name: 'Schifflange', slug: 'schifflange', population: 10196 }
    ]
  },
  {
    name: 'Iceland',
    slug: 'iceland',
    code: 'IS',
    population: 341243,
    topCities: [
      { name: 'Reykjavik', slug: 'reykjavik', population: 131136 },
      { name: 'Kópavogur', slug: 'kopavogur', population: 36956 },
      { name: 'Hafnarfjörður', slug: 'hafnarfjordur', population: 29799 },
      { name: 'Akureyri', slug: 'akureyri', population: 18925 },
      { name: 'Reykjanesbær', slug: 'reykjanesbaer', population: 17805 },
      { name: 'Garðabær', slug: 'gardabaer', population: 16299 },
      { name: 'Mosfellsbær', slug: 'mosfellsbaer', population: 11463 },
      { name: 'Árborg', slug: 'arborg', population: 9485 },
      { name: 'Akranes', slug: 'akranes', population: 7411 },
      { name: 'Fjarðabyggð', slug: 'fjardabyggd', population: 4639 }
    ]
  },
  {
    name: 'Brunei',
    slug: 'brunei',
    code: 'BN',
    population: 437479,
    topCities: [
      { name: 'Bandar Seri Begawan', slug: 'bandar-seri-begawan', population: 100700 },
      { name: 'Kuala Belait', slug: 'kuala-belait', population: 31178 },
      { name: 'Seria', slug: 'seria', population: 23639 },
      { name: 'Tutong', slug: 'tutong', population: 19151 },
      { name: 'Bangar', slug: 'bangar', population: 2449 },
      { name: 'Muara', slug: 'muara', population: 2102 },
      { name: 'Sukang', slug: 'sukang', population: 1000 },
      { name: 'Labi', slug: 'labi', population: 900 },
      { name: 'Lamunin', slug: 'lamunin', population: 800 },
      { name: 'Kampong Ayer', slug: 'kampong-ayer', population: 13000 }
    ]
  },
  {
    name: 'Bhutan',
    slug: 'bhutan',
    code: 'BT',
    population: 771608,
    topCities: [
      { name: 'Thimphu', slug: 'thimphu', population: 114551 },
      { name: 'Phuentsholing', slug: 'phuentsholing', population: 27658 },
      { name: 'Punakha', slug: 'punakha', population: 6262 },
      { name: 'Wangdue Phodrang', slug: 'wangdue-phodrang', population: 5832 },
      { name: 'Samdrup Jongkhar', slug: 'samdrup-jongkhar', population: 5104 },
      { name: 'Trashigang', slug: 'trashigang', population: 3827 },
      { name: 'Mongar', slug: 'mongar', population: 3502 },
      { name: 'Paro', slug: 'paro', population: 11448 },
      { name: 'Gelephu', slug: 'gelephu', population: 9858 },
      { name: 'Bajo', slug: 'bajo', population: 2596 }
    ]
  },
  {
    name: 'Maldives',
    slug: 'maldives',
    code: 'MV',
    population: 540544,
    topCities: [
      { name: 'Malé', slug: 'male', population: 133412 },
      { name: 'Addu City', slug: 'addu-city', population: 33731 },
      { name: 'Fuvahmulah', slug: 'fuvahmulah', population: 12380 },
      { name: 'Kulhudhuffushi', slug: 'kulhudhuffushi', population: 9164 },
      { name: 'Thinadhoo', slug: 'thinadhoo', population: 4500 },
      { name: 'Naifaru', slug: 'naifaru', population: 4200 },
      { name: 'Dhidhdhoo', slug: 'dhidhdhoo', population: 3900 },
      { name: 'Maradhoo', slug: 'maradhoo', population: 3500 },
      { name: 'Feeali', slug: 'feeali', population: 3200 },
      { name: 'Hulhumalé', slug: 'hulhumale', population: 50000 }
    ]
  },
  // NUEVOS PAÍSES PARA LLEGAR A 152
  {
    name: 'Palau',
    slug: 'palau',
    code: 'PW',
    population: 18094,
    topCities: [
      { name: 'Ngerulmud', slug: 'ngerulmud', population: 391 },
      { name: 'Koror', slug: 'koror', population: 11444 },
      { name: 'Airai', slug: 'airai', population: 2723 },
      { name: 'Melekeok', slug: 'melekeok', population: 271 },
      { name: 'Aimeliik', slug: 'aimeliik', population: 334 }
    ]
  },
  {
    name: 'Nauru',
    slug: 'nauru',
    code: 'NR',
    population: 10824,
    topCities: [
      { name: 'Yaren', slug: 'yaren', population: 1100 },
      { name: 'Denigomodu', slug: 'denigomodu', population: 1804 },
      { name: 'Nibok', slug: 'nibok', population: 484 },
      { name: 'Uaboe', slug: 'uaboe', population: 318 },
      { name: 'Aiwo', slug: 'aiwo', population: 1220 }
    ]
  },
  {
    name: 'Tuvalu',
    slug: 'tuvalu',
    code: 'TV',
    population: 11792,
    topCities: [
      { name: 'Funafuti', slug: 'funafuti', population: 6320 },
      { name: 'Vaitupu', slug: 'vaitupu', population: 1061 },
      { name: 'Nanumea', slug: 'nanumea', population: 664 },
      { name: 'Nui', slug: 'nui', population: 610 },
      { name: 'Nukufetau', slug: 'nukufetau', population: 586 }
    ]
  },
  {
    name: 'Marshall Islands',
    slug: 'marshall-islands',
    code: 'MH',
    population: 59190,
    topCities: [
      { name: 'Majuro', slug: 'majuro', population: 27797 },
      { name: 'Ebeye', slug: 'ebeye', population: 9614 },
      { name: 'Arno', slug: 'arno', population: 2069 },
      { name: 'Jabor', slug: 'jabor', population: 570 },
      { name: 'Wotje', slug: 'wotje', population: 865 }
    ]
  },
  {
    name: 'Micronesia',
    slug: 'micronesia',
    code: 'FM',
    population: 115023,
    topCities: [
      { name: 'Palikir', slug: 'palikir', population: 6647 },
      { name: 'Weno', slug: 'weno', population: 13802 },
      { name: 'Tofol', slug: 'tofol', population: 2624 },
      { name: 'Kolonia', slug: 'kolonia', population: 5681 },
      { name: 'Nett', slug: 'nett', population: 6158 }
    ]
  },
  {
    name: 'Kiribati',
    slug: 'kiribati',
    code: 'KI',
    population: 119449,
    topCities: [
      { name: 'Tarawa', slug: 'tarawa', population: 56388 },
      { name: 'Betio', slug: 'betio', population: 15755 },
      { name: 'Bikenibeu', slug: 'bikenibeu', population: 6177 },
      { name: 'Teaoraereke', slug: 'teaoraereke', population: 1993 },
      { name: 'Bonriki', slug: 'bonriki', population: 3280 }
    ]
  },
  {
    name: 'Saint Kitts and Nevis',
    slug: 'saint-kitts-and-nevis',
    code: 'KN',
    population: 53199,
    topCities: [
      { name: 'Basseterre', slug: 'basseterre', population: 14725 },
      { name: 'Charlestown', slug: 'charlestown-nevis', population: 1820 },
      { name: 'Dieppe Bay Town', slug: 'dieppe-bay-town', population: 2600 },
      { name: 'Sandy Point Town', slug: 'sandy-point-town', population: 3000 },
      { name: 'Cayon', slug: 'cayon', population: 2400 }
    ]
  },
  {
    name: 'Seychelles',
    slug: 'seychelles',
    code: 'SC',
    population: 98347,
    topCities: [
      { name: 'Victoria', slug: 'victoria-seychelles', population: 26450 },
      { name: 'Anse Boileau', slug: 'anse-boileau', population: 4183 },
      { name: 'Beau Vallon', slug: 'beau-vallon', population: 3800 },
      { name: 'Cascade', slug: 'cascade-seychelles', population: 2453 },
      { name: 'English River', slug: 'english-river', population: 1300 }
    ]
  }
];
